const SelectMyDashboardMenu = ({
  setOpenSelectGraphSlider,
  setEditSelectGraphShow,
  openAlertScreen,
  openDownloadScreen,
  setOpenDashboardListSlider,
  sourceHeader
}) => {
  const pathSegments = window.location.pathname.split('/');
  const isEditMode = pathSegments.includes('viewDashboardList'); // or however you determine editMode
  const isOperator = localStorage.getItem('is_operator') === 'true';
  const classType = sourceHeader && isOperator ? 'daz-header' : 'daz-sidebar';

  return (
    <div>
      {/* Sidebar dropdown */}
      <div className={`${classType}__hoverinfo shadow`}>
        {/* Select Graphs */}
        <div className={`${classType}__dropdown--item`}>
          <div
            className={`${classType}__hoverinfo--click ${isEditMode ? 'disabled-option' : ''}`}
            onClick={() => {
              if (isEditMode) return; // Prevent action in edit mode
              setOpenSelectGraphSlider(true);
              setEditSelectGraphShow(false);
              openAlertScreen && openAlertScreen('close_slider');
              openDownloadScreen && openDownloadScreen('close_slider');
            }}
            style={{ cursor: isEditMode ? 'not-allowed' : 'pointer', opacity: isEditMode ? 0.5 : 1 }}
          >
            Select Graphs
          </div>
        </div>

        {/* Saved Dashboard */}
        <div className={`${classType}__dropdown--item`}>
          <div
            className={`${classType}__hoverinfo--click`}
            onClick={() => {
               if (isEditMode) return;    
              setOpenDashboardListSlider(true);
              openAlertScreen && openAlertScreen('close_slider');
              openDownloadScreen && openDownloadScreen('close_slider');
              setOpenSelectGraphSlider(false);
            }}
              style={{ cursor: isEditMode ? 'not-allowed' : 'pointer', opacity: isEditMode ? 0.5 : 1 }}
          >
            Saved Dashboard
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectMyDashboardMenu;
